import React from "react";
import { Link, LinkProps } from "@jasperlabs/jux-next";

type UrlOrFile =
	| {
			type: "url" | "file";
			url: string | null;
			fileUrl: string | null;
	  }
	| {
			type: "url" | "file";
			url: string | null;
			fileUrl: string | null;
	  };

function SanityUrlOrFileLink({
	urlOrFile,
	children,
	...props
}: Omit<LinkProps<"a">, "href" | "children"> & {
	children?: React.ReactNode;
	urlOrFile: UrlOrFile;
}) {
	const { type, url, fileUrl } = urlOrFile;

	if (type === "url") {
		return (
			<Link href={url ?? ""} target="_blank" {...props}>
				{children}
			</Link>
		);
	}

	return (
		<Link href={fileUrl ?? ""} target="_blank" {...props}>
			{children}
		</Link>
	);
}

export default SanityUrlOrFileLink;
